import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useState,
} from "react";
import { TrackedCreatorWrapper } from "schemas/dashboard";

interface TrackedCreatorsContextInterface {
  trackedCreatorSideBar: TrackedCreatorWrapper | null;
  setTrackedCreatorSideBar: Dispatch<
    SetStateAction<TrackedCreatorWrapper | null>
  >;
  trackedCreators: TrackedCreatorWrapper[];
  setTrackedCreators: Dispatch<SetStateAction<TrackedCreatorWrapper[]>>;
  updateTrackedCreator: (newWrapper: TrackedCreatorWrapper) => void;
}

const defaultContextMissingFunction = () => {
  throw new Error("TrackedCreatorsContext is missing");
};

const defaultInterface: TrackedCreatorsContextInterface = {
  trackedCreatorSideBar: null,
  setTrackedCreatorSideBar: defaultContextMissingFunction,
  trackedCreators: [],
  setTrackedCreators: defaultContextMissingFunction,
  updateTrackedCreator: defaultContextMissingFunction,
};

const TrackedCreatorsContext =
  createContext<TrackedCreatorsContextInterface>(defaultInterface);

interface TrackedCreatorsProviderProps {
  children: React.ReactNode;
}

const TrackedCreatorsProvider = ({
  children,
}: TrackedCreatorsProviderProps) => {
  const [trackedCreatorSideBar, setTrackedCreatorSideBar] =
    useState<TrackedCreatorWrapper | null>(null);

  const [trackedCreators, setTrackedCreators] = useState<
    TrackedCreatorWrapper[]
  >([]);

  const updateTrackedCreator = (newWrapper: TrackedCreatorWrapper) => {
    if (
      !!trackedCreatorSideBar &&
      trackedCreatorSideBar.trackedCreator.id === newWrapper.trackedCreator.id
    ) {
      setTrackedCreatorSideBar(newWrapper);
    }
    setTrackedCreators((prev) =>
      prev.map((trackedCreatorWrapper) => {
        if (
          trackedCreatorWrapper.trackedCreator.id ===
          newWrapper.trackedCreator.id
        ) {
          return newWrapper;
        }
        return trackedCreatorWrapper;
      }),
    );
  };

  return (
    <TrackedCreatorsContext.Provider
      value={{
        trackedCreatorSideBar,
        setTrackedCreatorSideBar,
        trackedCreators,
        setTrackedCreators,
        updateTrackedCreator,
      }}
    >
      {children}
    </TrackedCreatorsContext.Provider>
  );
};

export { TrackedCreatorsProvider, TrackedCreatorsContext };
